<template>
  <div>
    <div class="row">
      <section>
        <h1>
          <translate translate-context="Content/Platforms/Header"
            >Supported Platforms</translate
          >
        </h1>
        <p>
          <translate translate-context="Content/Platforms/Paragraph">
            Retribute can be used with a range of existing applications and
            donation platforms, giving you plenty of options for supporting your
            favorite people.
          </translate>
        </p>
        <p>
          <strong>
            <translate translate-context="Content/Platforms/Paragraph"
              >As a free and open-source standard, you can get involved by
              adding support for Retribute to your platform.</translate
            >
          </strong>
        </p>
        <ul>
          <li>
            <a href="https://dev.funkwhale.audio/retribute.me" target="_blank">
              <translate translate-context="Content/Platforms/Link"
                >Browse our source code</translate
              >
            </a>
          </li>
          <li>
            <a href="https://governance.funkwhale.audio" target="_blank">
              <translate translate-context="Content/Platforms/Link"
                >Join our forums</translate
              >
            </a>
          </li>
        </ul>
        <a class="pure-button" href="#fedi-platforms">
          <i class="fa fa-activitypub"></i>&nbsp;
          <translate translate-context="Content/Platforms.FAQ/Link"
            >Fediverse Platforms</translate
          >
        </a>
        <a class="pure-button" href="#donation-platforms">
          <i class="fa fa-eur"></i>&nbsp;
          <translate translate-context="Content/Platforms.FAQ/Link"
            >Donation Platforms</translate
          >
        </a>
        <h2 id="fedi-platforms">Fediverse Platforms</h2>
        <div class="apps-list">
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/funkwhale.png" />
            </div>
            <div class="content">
              <h3>
                <a href="https://funkwhale.audio" target="blank" rel="noopener"
                  >Funkwhale</a
                >
              </h3>

              <p>
                <translate translate-context="Content/Platforms/Paragraph"
                  >A free, decentralized audio streaming platform</translate
                >
              </p>
            </div>
          </div>
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/mastodon.png" />
            </div>
            <div class="content">
              <h3>
                <a href="https://joinmastodon.org" target="blank" rel="noopener"
                  >Mastodon</a
                >
              </h3>
              <p>
                <translate translate-context="Content/Platforms/Paragraph"
                  >A self-hosted, free social networking service</translate
                >
              </p>
            </div>
          </div>
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/peertube.png" />
            </div>
            <div class="content">
              <h3>
                <a
                  href="https://joinpeertube.org/"
                  target="blank"
                  rel="noopener"
                  >Peertube</a
                >
              </h3>
              <p>
                <translate translate-context="Content/Platforms/Paragraph"
                  >A free, decentralized video streaming platform</translate
                >
              </p>
            </div>
          </div>
        </div>
        <h2 id="donation-platforms">Donation Platforms</h2>
        <div class="apps-list">
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/bandcamp.png" />
            </div>
            <div class="content">
              <h3>
                <a href="https://bandcamp.com" target="blank" rel="noopener"
                  >Bandcamp</a
                >
              </h3>
            </div>
          </div>
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/etsy.png" />
            </div>
            <div class="content">
              <h3>
                <a href="https://etsy.com" target="blank" rel="noopener"
                  >Etsy</a
                >
              </h3>
            </div>
          </div>
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/flattr.png" />
            </div>
            <div class="content">
              <h3>
                <a href="https://flattr.com" target="blank" rel="noopener"
                  >Flattr</a
                >
              </h3>
            </div>
          </div>
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/itchio.png" />
            </div>
            <div class="content">
              <h3>
                <a href="https://itch.io" target="blank" rel="noopener"
                  >itch.io</a
                >
              </h3>
            </div>
          </div>
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/kofi.png" />
            </div>
            <div class="content">
              <h3>
                <a href="https://ko-fi.com" target="blank" rel="noopener"
                  >Ko-Fi</a
                >
              </h3>
            </div>
          </div>
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/liberapay.png" />
            </div>
            <div class="content">
              <h3>
                <a href="https://liberapay.com" target="blank" rel="noopener"
                  >Liberapay</a
                >
              </h3>
            </div>
          </div>
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/opencollective.png" />
            </div>
            <div class="content">
              <h3>
                <a
                  href="https://opencollective.com"
                  target="blank"
                  rel="noopener"
                  >OpenCollective</a
                >
              </h3>
            </div>
          </div>
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/patreon.png" />
            </div>
            <div class="content">
              <h3>
                <a href="https://patreon.com" target="blank" rel="noopener"
                  >Patreon</a
                >
              </h3>
            </div>
          </div>
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/paypal.png" />
            </div>
            <div class="content">
              <h3>
                <a href="https://paypal.com" target="blank" rel="noopener"
                  >PayPal</a
                >
              </h3>
            </div>
          </div>
          <div class="app-card">
            <div class="img-wrapper">
              <img src="../assets/logos/tipeee.png" />
            </div>
            <div class="content">
              <h3>
                <a href="https://tipeee.com" target="blank" rel="noopener"
                  >Tipeee</a
                >
              </h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import PageMixin from "../PageMixin";

export default {
  mixins: [PageMixin],
  methods: {
    getInnerTitle() {
      return this.$pgettext("HTML/Meta/Title", "Supported Platforms");
    }
  }
};
</script>
